import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { DataserviceService } from '../dataservice.service';
import { CustomerHistory } from '../payroll/payroll.types';

export interface PayrollResult {
  userId: string;
  userName: string;
  totalCommission: number;
  customers: {
    customerId: string;
    customerName: string;
    commission: number;
  }[];
}

@Injectable({
  providedIn: 'root'
})
export class PayrollService {
  private apiUrl = `${environment.baseUrl}payplans`;

  constructor(private http: HttpClient, private dataService: DataserviceService) {}

  calculatePayroll(payplanId: any): Observable<any> {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .set('Authorization', `Bearer ${this.dataService.getAuthToken()}`)
      .set('Refresh', `${this.dataService.getRefreshToken()}`);
    return this.http.post<{ success: boolean; results: PayrollResult[] }>(
      `${this.apiUrl}/calculate/${payplanId}`,
      {},
      { headers }
    );
  }

  getPayrollResults(payplanId: number): Observable<{ results: PayrollResult[] }> {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .set('Authorization', `Bearer ${this.dataService.getAuthToken()}`)
      .set('Refresh', `${this.dataService.getRefreshToken()}`);
    return this.http.get<{ results: PayrollResult[] }>(
      `${this.apiUrl}/results/${payplanId}`,
      { headers }
    );
  }
}
